import * as hljs from 'highlight.js';

import vue from './vue';

hljs.registerLanguage('vue', vue);



// WEBPACK FOOTER //
// ./src/languages/index.js